export const X_GAP = 96;
export const Y_GAP = 50;
export const NAME_GAP = 28;
export const NAME_LINE_PADDING = NAME_GAP * 0.2;
export const RANK_DELTA_Y = 18;
export const TAGS_DELTA_Y = 12;
export const NODE_RADIUS = 6;
export const CORNER_RADIUS = 6;
export const MAX_ITEMS_IN_BREADCRUMBS = 5;
export const DATA_BUTTONS_GAP = 120;
export const DATA_BUTTONS_MAX_TEXT_LENGTH = 150;
export const RIGHT_PADDING_WITH_LEAVES = 600;
export const RIGHT_PADDING_WITHOUT_LEAVES = 380;
export const EXTERNAL_LINK_GAP = 24;
export const EXTERNAL_LINK_SIZE = 10;
export const DERIVATIVES_PADDING = 16;
